import {AdminSessionValueObject} from "../../model/vo/admin/AdminSessionValueObject";
import {DefaultIO, defaultIO} from "../DefaultIO";
import {httpClient} from "../HttpClient";

type IOType = Readonly<Omit<DefaultIO<AdminSessionValueObject>, 'post' | 'put' | 'delete'>> & {
    getCurrent(): Promise<AdminSessionValueObject>;
    deleteCurrent(): Promise<void>;
};

export const AdminSessionIO: IOType = Object.freeze({
    ...defaultIO(
        '/api/v3/admins/sessions',
        AdminSessionValueObject.construct
    ),
    getCurrent(): Promise<AdminSessionValueObject> {
        return httpClient.get('/api/v3/admins/sessions/current', AdminSessionValueObject.construct);
    },
    deleteCurrent() {
        return httpClient.delete('/api/v3/admins/sessions/current');
    }
})